import React, { useEffect, useState } from "react";
import { getDatabase, ref, get } from "firebase/database";
import { useNavigate } from "react-router-dom";

function SoldProductsPage({ uid }) {
  const [orders, setOrders] = useState([]);
  const [products, setProducts] = useState({});
  const [soldProducts, setSoldProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Filters
  const [selectedStatus, setSelectedStatus] = useState("Tous");
  const [selectedBrand, setSelectedBrand] = useState("Tous");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Stats
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [totalPurchase, setTotalPurchase] = useState(0);
  const [totalProfit, setTotalProfit] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);

   const [expandedRows, setExpandedRows] = useState({});

    const toggleRow = (productKey) => {
    setExpandedRows(prev => ({
      ...prev,
      [productKey]: !prev[productKey]
    }));
  };

  const navigate = useNavigate();

  const handlePrint = () => {
  // تجهيز بيانات الفلترة
  const filters = {
    selectedStatus,
    selectedBrand
  };
  
  const dateRange = {
    start: startDate,
    end: endDate
  };

   navigate('/print-report', {
    state: {
      soldProducts,
      totalRevenue,
      totalPurchase,
      totalProfit,
      totalQuantity,
      filters,
      dateRange
    }
  });
};

  // ✅ دالة لعرض رقم الطلبية
const formatOrderNumber = (order) => {
  // إذا كان orderNumber موجوداً استخدمه
  if (order.orderNumber) {
    return order.orderNumber;
  }
  // إذا كان orderId موجوداً استخدم آخر 4 أرقام منه
  if (order.orderId) {
    return order.orderId.slice(-4);
  }
  return 'N/A';
};

// ✅ دالة للحصول على لون البadge حسب الحالة
const getStatusBadge = (status) => {
  const baseStyle = {
    padding: '2px 6px',
    borderRadius: '4px',
    fontSize: '11px',
    fontWeight: '500'
  };
  
  switch(status) {
    case 'Livré':
    case 'Terminé':
      return {...baseStyle, backgroundColor: '#dcfce7', color: '#166534'};
    case 'En Préparation':
      return {...baseStyle, backgroundColor: '#fef9c3', color: '#854d0e'};
    case 'Annulé':
      return {...baseStyle, backgroundColor: '#fee2e2', color: '#991b1b'};
    default:
      return {...baseStyle, backgroundColor: '#e2e8f0', color: '#334155'};
  }
};

  const [totalOrdersWithDiscount, setTotalOrdersWithDiscount] = useState(0);

  const [brands, setBrands] = useState(["Tous"]);

  const statuses = [
    "Tous", "Reçu", "En Préparation", "Sortir en Livraison", 
    "Livré", "Terminé", "Annulé"
  ];

  const db = getDatabase();

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    setLoading(true);
    try {
      console.log("Loading data for uid:", uid);
      
      const [ordersSnap, productsSnap, brandsSnap] = await Promise.all([
        get(ref(db, `distributors/${uid}/orders`)),
        get(ref(db, `distributors/${uid}/products`)),
        get(ref(db, `distributors/${uid}/brands`))
      ]);

      // Products - نخزنها بالمفتاح الحقيقي
      let productsMap = {};
      if (productsSnap.exists()) {
        productsSnap.forEach((p) => {
          const productData = p.val();
          productsMap[p.key] = {
            id: p.key,
            name: productData.name || "Inconnu",
            brandName: productData.brandName || "Inconnue",
            price: productData.price || 0,
            purchasePrice: productData.purchasePrice || 0,
            categoryName: productData.categoryName || ""
          };
        });
      }
      console.log("Products loaded:", Object.keys(productsMap).length);
      setProducts(productsMap);

      // Brands
      let brandsList = ["Tous"];
      if (brandsSnap.exists()) {
        brandsSnap.forEach((b) => {
          const brandName = b.val()?.name;
          if (brandName) brandsList.push(brandName);
        });
      }
      setBrands(brandsList);

      // Orders
      let ordersList = [];
      if (ordersSnap.exists()) {
        ordersSnap.forEach((o) => {
          ordersList.push({ id: o.key, ...o.val() });
        });
      }
      console.log("Orders loaded:", ordersList.length);
      setOrders(ordersList);
    } catch (err) {
      console.error("Error:", err);
      alert("Erreur lors du chargement des données");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (orders.length > 0) {
      calculateStats();
    }
  }, [orders, products, selectedStatus, selectedBrand, startDate, endDate]);
function calculateStats() {
  if (!orders.length) return;

  const map = new Map();
  let revenue = 0;
  let purchase = 0;
  let quantity = 0;
  let totalOrdersWithDiscount = 0;

  const start = startDate ? new Date(startDate).getTime() : 0;
  const end = endDate ? new Date(endDate).getTime() : Number.MAX_SAFE_INTEGER;

  orders.forEach(order => {
    const status = (order.status || "").trim();
    if (!status) return;
    const orderDate = Number(order.createdAt) || 0;
    if (orderDate < start || orderDate > end) return;
    if (status === "Annulé" && selectedStatus !== "Annulé") return;
    if (selectedStatus !== "Tous" && status !== selectedStatus) return;
    if (!order.products) return;

    let orderTotal = 0;

    Object.entries(order.products).forEach(([productKey, p]) => {
      const realProductId = p.id || p.productKey || productKey;
      
      const distributorProduct = products[realProductId] || {};
      const name = distributorProduct.name || p.name || "Unknown Product";
      const brand = distributorProduct.brandName || p.brandName || "Unknown Brand";
      
      // ✅ قراءة سعر الشراء من الطلبية أولاً
      let purchasePrice = 0;
      if (p.purchasePrice !== undefined && p.purchasePrice !== null) {
        purchasePrice = Number(p.purchasePrice);
      } else {
        purchasePrice = Number(distributorProduct.purchasePrice) || 0;
      }
      
      const qty = parseInt(p.actualQuantity || p.quantity || 0);
      if (qty === 0) return;
      
      const salePrice = parseFloat(p.price || distributorProduct.price || 0) || 0;

      if (selectedBrand !== "Tous" && brand.toLowerCase() !== selectedBrand.toLowerCase()) return;

      // ✅ المفتاح الفريد = المنتج + سعر البيع + سعر الشراء
      const uniqueKey = `${realProductId}_${salePrice}_${purchasePrice}`;

      if (!map.has(uniqueKey)) {
        map.set(uniqueKey, {
          id: realProductId,
          name: name || "",
          brand: brand || "",
          purchasePrice: purchasePrice || 0,
          salePrice: salePrice || 0,
          quantity: 0,
          total: 0,
          ordersCount: 0,
          // ✅ تخزين تفاصيل كل طلبية على حدة
          orderDetails: []
        });
      }

      const sp = map.get(uniqueKey);
      sp.quantity += qty;
      sp.ordersCount += 1;
      sp.total += salePrice * qty;
      
      // ✅ تخزين تفاصيل هذه الطلبية
      sp.orderDetails.push({
        orderId: order.id,
        orderNumber: order.orderNumber,
        orderDate: orderDate,
        quantity: qty,
        salePrice: salePrice,
        purchasePrice: purchasePrice,
        status: status
      });

      if (status !== "Annulé") {
        revenue += salePrice * qty;
        purchase += purchasePrice * qty;
        quantity += qty;
      }

      orderTotal += salePrice * qty;
    });

    totalOrdersWithDiscount += parseFloat(order.finalPrice) || orderTotal || 0;
  });

  // تحويل map إلى مصفوفة
  const soldProductsArray = Array.from(map.values())
    .sort((a, b) => b.quantity - a.quantity)
    .map(product => ({
      ...product,
      // ✅ ترتيب تفاصيل الطلبيات حسب التاريخ
      orderDetails: product.orderDetails.sort((a, b) => b.orderDate - a.orderDate)
    }));

  console.log("Sold Products with details:", soldProductsArray);
  
  setSoldProducts(soldProductsArray);
  setTotalRevenue(revenue || 0);
  setTotalPurchase(purchase || 0);
  setTotalProfit((revenue - purchase) || 0);
  setTotalQuantity(quantity || 0);
  setTotalOrdersWithDiscount(totalOrdersWithDiscount || 0);
}


const formatMoney = (amount) => {
  const num = Number(amount) || 0;
  return num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " DA";
};
// ✅ تحسين دالة formatMoney لتكون آمنة

  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.loadingSpinner}></div>
        <p style={styles.loadingText}>Chargement...</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <h1 style={styles.title}>📊 Statistiques des Ventes</h1>
        <button onClick={loadData} style={styles.refreshButton}>
          🔄 Actualiser
        </button>
      </div>

      {/* Filters */}
      <div style={styles.filtersContainer}>
        <select 
          style={styles.select}
          value={selectedStatus}
          onChange={(e) => setSelectedStatus(e.target.value)}
        >
          {statuses.map(s => <option key={s}>{s}</option>)}
        </select>

        <select 
          style={styles.select}
          value={selectedBrand}
          onChange={(e) => setSelectedBrand(e.target.value)}
        >
          {brands.map(b => <option key={b}>{b}</option>)}
        </select>

        <input
          type="date"
          style={styles.dateInput}
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />

        <input
          type="date"
          style={styles.dateInput}
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
      </div>

      {/* Stats Cards */}
      <div style={styles.statsGrid}>
        <div style={{...styles.statCard, borderLeftColor: '#3b82f6'}}>
          <div style={styles.statLabel}>💰 Chiffre d'affaires</div>
          <div style={styles.statValue}>{formatMoney(totalRevenue)}</div>
        </div>

        <div style={{...styles.statCard, borderLeftColor: '#f97316'}}>
          <div style={styles.statLabel}>📦 Coût d'achat</div>
          <div style={styles.statValue}>{formatMoney(totalPurchase)}</div>
        </div>

        <div style={{...styles.statCard, borderLeftColor: '#22c55e'}}>
          <div style={styles.statLabel}>📈 Bénéfice</div>
          <div style={styles.statValue}>{formatMoney(totalProfit)}</div>
        </div>

        <div style={{...styles.statCard, borderLeftColor: '#a855f7'}}>
          <div style={styles.statLabel}>📊 Quantité vendue</div>
          <div style={styles.statValue}>{totalQuantity}</div>
        </div>

      
      </div>

      {/* بعد بطاقات الإحصائيات وقبل الجدول */}
<div style={styles.printButtonContainer}>
  <button 
    onClick={handlePrint}
    style={styles.printButton}
    disabled={soldProducts.length === 0}
  >
    🖨️ Imprimer le rapport
  </button>
</div>

 {/* Products Table */}
<div style={styles.tableContainer}>
  {soldProducts.length > 0 ? (
    <table style={styles.table}>
      <thead>
        <tr style={styles.tableHeader}>
          <th style={styles.tableHeaderCell}>Produit</th>
          <th style={styles.tableHeaderCell}>Marque</th>
          <th style={styles.tableHeaderCell}>Prix Achat</th>
          <th style={styles.tableHeaderCell}>Prix Vente</th>
          <th style={styles.tableHeaderCell}>Quantité</th>
          <th style={styles.tableHeaderCell}>Nb Commandes</th>
          <th style={styles.tableHeaderCell}>Total</th>
          <th style={styles.tableHeaderCell}></th>
        </tr>
      </thead>
      <tbody>
        {soldProducts.map((product, index) => {
          const productKey = `${product.id}_${product.salePrice}_${product.purchasePrice}`;
          const isExpanded = expandedRows[productKey];
          
          return (
            <React.Fragment key={productKey}>
              {/* الصف الرئيسي */}
              <tr style={index % 2 === 0 ? styles.tableRowEven : styles.tableRowOdd}>
                <td style={styles.tableCell}>{product.name}</td>
                <td style={styles.tableCell}>
                  <span style={{...styles.badge, backgroundColor: '#e0f2fe', color: '#0369a1'}}>
                    {product.brand}
                  </span>
                </td>
                <td style={{...styles.tableCell, textAlign: 'right', fontWeight: 'bold', color: '#dc2626'}}>
                  {formatMoney(product.purchasePrice)}
                </td>
                <td style={{...styles.tableCell, textAlign: 'right', fontWeight: 'bold', color: '#2563eb'}}>
                  {formatMoney(product.salePrice)}
                </td>
                <td style={{...styles.tableCell, textAlign: 'right', fontWeight: 'bold'}}>{product.quantity}</td>
                <td style={{...styles.tableCell, textAlign: 'center'}}>
                  <span style={{...styles.badge, backgroundColor: '#f3e8ff', color: '#6b21a8'}}>
                    {product.ordersCount}
                  </span>
                </td>
                <td style={{...styles.tableCell, textAlign: 'right', fontWeight: 'bold', color: '#059669'}}>
                  {formatMoney(product.total)}
                </td>
                <td style={styles.tableCell}>
                  <button 
                    onClick={() => toggleRow(productKey)}
                    style={styles.detailButton}
                  >
                    {isExpanded ? '🔽' : '▶️'} Détails
                  </button>
                </td>
              </tr>
              
              {/* صف التفاصيل (يظهر فقط إذا كان مفتوحاً) */}
             {/* صف التفاصيل (يظهر فقط إذا كان مفتوحاً) */}
{isExpanded && (
  <tr>
    <td colSpan="8" style={{padding: '0', backgroundColor: '#f9f9f9'}}>
      <div style={styles.detailsContainer}>
        <h4 style={styles.detailsTitle}>📋 Détails des ventes</h4>
        {product.orderDetails && product.orderDetails.length > 0 ? (
          <table style={styles.detailsTable}>
            <thead>
              <tr>
                <th style={{...styles.detailsHeader, textAlign: 'left'}}>Date</th>
                <th style={{...styles.detailsHeader, textAlign: 'left'}}>N° Commande</th>
                <th style={{...styles.detailsHeader, textAlign: 'right'}}>Quantité</th>
                <th style={{...styles.detailsHeader, textAlign: 'right'}}>Prix Vente</th>
                <th style={{...styles.detailsHeader, textAlign: 'right'}}>Prix Achat</th>
                <th style={{...styles.detailsHeader, textAlign: 'left'}}>Statut</th>
              </tr>
            </thead>
            <tbody>
              {product.orderDetails.map((detail, i) => (
                <tr key={i}>
                  <td style={{...styles.detailsCell, textAlign: 'left'}}>
                    {new Date(detail.orderDate).toLocaleDateString()}
                  </td>
                  <td style={{...styles.detailsCell, textAlign: 'left'}}>
                    <span style={styles.orderNumber}>
                      {detail.orderNumber || (detail.orderId ? detail.orderId.slice(-4) : 'N/A')}
                    </span>
                  </td>
                  <td style={{...styles.detailsCell, textAlign: 'right'}}>{detail.quantity}</td>
                  <td style={{...styles.detailsCell, textAlign: 'right', color: '#2563eb'}}>
                    {formatMoney(detail.salePrice)}
                  </td>
                  <td style={{...styles.detailsCell, textAlign: 'right', color: '#dc2626'}}>
                    {formatMoney(detail.purchasePrice)}
                  </td>
                  <td style={{...styles.detailsCell, textAlign: 'left'}}>
                    <span style={getStatusBadge(detail.status)}>
                      {detail.status || 'N/A'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p style={styles.noDetails}>Aucun détail disponible</p>
        )}
      </div>
    </td>
  </tr>
)}            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  ) : (
    <div style={styles.emptyState}>
      <p style={styles.emptyMessage}>Aucun produit trouvé</p>
    </div>
  )}
</div>
    </div>
  );
}

const styles = {
  container: {
    padding: '24px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    backgroundColor: '#f8fafc',
    minHeight: '100vh'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px'
  },
  title: {
    fontSize: '28px',
    fontWeight: '600',
    color: '#1e293b',
    margin: 0
  },
  refreshButton: {
    padding: '8px 16px',
    backgroundColor: '#f1f5f9',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    color: '#475569',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'all 0.2s'
  },
  filtersContainer: {
    display: 'flex',
    gap: '12px',
    marginBottom: '24px',
    flexWrap: 'wrap'
  },
  select: {
    padding: '8px 12px',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    backgroundColor: 'white',
    minWidth: '160px',
    fontSize: '14px',
    color: '#1e293b'
  },
  dateInput: {
    padding: '8px 12px',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    backgroundColor: 'white',
    fontSize: '14px',
    color: '#1e293b'
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: '16px',
    marginBottom: '32px'
  },
  statCard: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    borderLeftWidth: '4px',
    borderLeftStyle: 'solid',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
  },
  statLabel: {
    fontSize: '14px',
    color: '#64748b',
    marginBottom: '8px'
  },
  statValue: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#0f172a'
  },
  tableContainer: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    minHeight: '200px'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },
  tableHeader: {
    backgroundColor: '#f1f5f9'
  },
  tableHeaderCell: {
    padding: '12px 16px',
    textAlign: 'left',
    fontSize: '13px',
    fontWeight: '600',
    color: '#475569',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  tableRowEven: {
    backgroundColor: 'white'
  },
  tableRowOdd: {
    backgroundColor: '#fafafa'
  },
  tableCell: {
    padding: '12px 16px',
    fontSize: '14px',
    color: '#334155',
    borderBottom: '1px solid #f1f5f9'
  },
  tableFooter: {
    backgroundColor: '#f8fafc',
    borderTop: '2px solid #e2e8f0'
  },
  badge: {
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: '500',
    display: 'inline-block'
  },
  emptyState: {
    padding: '48px',
    textAlign: 'center'
  },
  emptyMessage: {
    color: '#94a3b8',
    fontSize: '16px',
    margin: 0
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#f8fafc'
  },
  loadingSpinner: {
    width: '40px',
    height: '40px',
    border: '3px solid #e2e8f0',
    borderTopColor: '#3b82f6',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  },
  detailButton: {
    padding: '4px 8px',
    backgroundColor: 'transparent',
    border: '1px solid #e2e8f0',
    borderRadius: '4px',
    color: '#475569',
    cursor: 'pointer',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    transition: 'all 0.2s'
  },
   detailsContainer: {
    padding: '16px',
    backgroundColor: '#f8fafc',
    borderTop: '1px solid #e2e8f0',
    borderBottom: '1px solid #e2e8f0'
  },
  detailsTitle: {
    margin: '0 0 12px 0',
    fontSize: '14px',
    fontWeight: '600',
    color: '#334155'
  },
   detailsTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '12px'
  },
  detailsHeader: {
    textAlign: 'left',
    padding: '8px',
    backgroundColor: '#e2e8f0',
    color: '#475569',
    fontWeight: '600'
  },
  detailsCell: {
    padding: '8px',
    borderBottom: '1px solid #e2e8f0',
    color: '#334155'
  },
  orderNumber: {
    fontFamily: 'monospace',
    fontWeight: '600',
    color: '#6b21a8'
  },
   noDetails: {
    color: '#94a3b8',
    fontSize: '12px',
    fontStyle: 'italic',
    margin: '8px 0'
  
},
printButtonContainer: { 
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: '16px'
},
printButtonContainer: {
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: '16px'
},
printButton: {
  padding: '10px 20px',
  backgroundColor: '#2563eb',
  color: 'white',
  border: 'none',
  borderRadius: '6px',
  fontSize: '14px',
  fontWeight: '500',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  transition: 'background-color 0.2s'
 
},


  loadingText: {
    marginTop: '16px',
    color: '#64748b',
    fontSize: '16px'
  }
};

// Add keyframes for spinner animation
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);

export default SoldProductsPage;